module.exports = __webpack_public_path__ + "img/ipad.a0cb8c37.png";